var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTmShare = function SvgTmShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.716 18.542H7.283c-4.092 0-5.842-1.75-5.842-5.842v-.108c0-3.7 1.459-5.484 4.725-5.792a.643.643 0 0 1 .684.567.626.626 0 0 1-.567.683c-2.617.242-3.592 1.475-3.592 4.55v.108c0 3.392 1.2 4.592 4.592 4.592h5.433c3.392 0 4.592-1.2 4.592-4.592V12.6c0-3.092-.992-4.325-3.658-4.55a.624.624 0 0 1 .108-1.242c3.317.284 4.8 2.075 4.8 5.8v.109c0 4.075-1.75 5.825-5.842 5.825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 13.125a.63.63 0 0 1-.625-.625V3.017A.63.63 0 0 1 10 2.392a.63.63 0 0 1 .625.625V12.5a.63.63 0 0 1-.625.625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.791 5.5a.62.62 0 0 1-.441-.183L10 2.967l-2.35 2.35a.63.63 0 0 1-.884 0 .63.63 0 0 1 0-.884l2.792-2.791a.63.63 0 0 1 .883 0l2.792 2.791a.63.63 0 0 1 0 .884.6.6 0 0 1-.442.183"
  })));
};
export default SvgTmShare;